// app/dashboard/dashboard_Personale.js

(function () {
    'use strict';
    var controllerId = 'dashboard_Personale';
    angular.module('app').controller(controllerId, ['$rootScope', '$scope', '$filter', '_', 'common', 'datacontext', 'sectionMenu', '$uibModal', '$translate', 'amMoment', 'tmhDynamicLocale', dashboard_PersonaleFn]);

    function dashboard_PersonaleFn($rootScope, $scope, $filter, _, common, datacontext, sectionMenu, $uibModal, $translate, amMoment, tmhDynamicLocale) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = " dashview";
        var vm = this;
        vm.title = $translate.instant('Gestore');
        vm.sectionMenu = sectionMenu.setSection('');
        vm.getAll = getDashboard;
        vm.dipendente = {};
        vm.dashboard = {};
        vm.dashboard.ordinarioG = 0;
        vm.dashboard.straordinarioG = 0;
        vm.dashboard.viaggioG = 0;
        vm.dashboard.giustificativiG = 0;
        vm.dashboard.trasfertaG = 0;
        vm.dashboard.totaleG = 0;
        vm.dashboard.ordinarioS = 0;
        vm.dashboard.straordinarioS = 0;
        vm.dashboard.viaggioS = 0;
        vm.dashboard.giustificativiS = 0;
        vm.dashboard.trasfertaS = 0;
        vm.dashboard.totaleS = 0;
        vm.dashboard.ordinarioM = 0;
        vm.dashboard.straordinarioM = 0;
        vm.dashboard.viaggioM = 0;
        vm.dashboard.giustificativiM = 0;
        vm.dashboard.trasfertaM = 0;
        vm.dashboard.totaleM = 0;

        vm.currentLanguage = $translate.proposedLanguage() || $translate.use();     //Forzatura della lingua
        amMoment.changeLocale(vm.currentLanguage);                                  //Forzatura della lingua
        tmhDynamicLocale.set(vm.currentLanguage);                                   //Forzatura della lingua

        vm.strMese = '';
        var today = moment();
        vm.fMese = today.month() + 1;
        vm.fAnno = today.year();
        vm.strMese = common.strMese(vm.fMese, vm.currentLanguage);

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [$rootScope.getWhoAmI()];
            common.activateController(promises, controllerId)
                .then(function () {
                    getDashboard();
                    getPerformance();
                    
                    if ($rootScope.avvisoCV && $rootScope.statoCV < 7) {
                        $uibModal.open({
                            templateUrl: '/app/dashboard/modal/avvisoCurriculum.html?version=30',
                            controller: 'avvisoCurriculum'
                        });
                    }
                });
        }

        //****************************************************
        // METODI 
        //****************************************************       
        function getDashboard() {
            datacontext.dashboard_get().then(function (data) {
                vm.dashboard = data;
            });
        }

        function getPerformance() {
            //Inizializzo la scala del grafico
            vm.maxValue = 10;
            vm.loading = true;
            $scope.graficoPerformance = {
                'type': 'AreaChart',
                'options': {
                    'legend': { 'position': 'none' },
                    'colors': ['#002854'],
                    'vAxis': {
                        'title': $translate.instant('OreLavoro'),
                        'titleTextStyle': { color: '#333' },
                        'minValue': 0,
                        'maxValue': parseInt(vm.maxValue)
                    },
                    'hAxis': {
                        'textPosition': 'none',
                        'gridlines': { 'count': 10 }
                    },
                    'pointSize': 8
                },
                'formatters': {
                    'number': [
                        {
                            'columnNum': 1,
                            'decimalSymbol': ',',
                            'fractionDigits': 2,
                            'groupingSymbol': '.'
                        }
                    ]
                }
            };

            //Inizializzo il grafico
            $scope.graficoPerformance.data = {
                "cols": [
                    { id: "description", label: "Data", type: "string" },
                    { id: "ore", label: $translate.instant('OreLavoro'), type: "number" }
                ],
                "rows": []
            };

            datacontext.reportOre_getSum(vm.fAnno, vm.fMese, 0, 0, -1, -1, '', -1, 0).then(function (data) {
                if (data == null || data == "500" || data.length == 0) {
                    $scope.graficoPerformance.data = {
                        "cols": [
                            { id: "description", label: "Data", type: "string" },
                            { id: "ore", label: $translate.instant('OreLavoro'), type: "number" }
                        ],
                        "rows": []
                    };

                    vm.loading = false;
                    return;
                }

                var sortedPerformance = _.sortBy(data, 'Giorno');
                vm.primaData = $filter('dateFromValues')(_.first(sortedPerformance).Giorno, _.first(sortedPerformance).Mese, _.first(sortedPerformance).Anno);
                vm.ultimaData = $filter('dateFromValues')(_.last(sortedPerformance).Giorno, _.last(sortedPerformance).Mese, _.last(sortedPerformance).Anno);

                $scope.graficoPerformance.data = {
                    "cols": [
                        { id: "description", label: "Data", type: "string" },
                        { id: "ore", label: $translate.instant('OreLavoro'), type: "number" }
                    ],
                    "rows": []
                };

                sortedPerformance.forEach(function (obj) {
                    var item = {};
                    item.c = [];
                    var tmpMaxValue = vm.maxValue;

                    var desc = $filter('dateFromValues')(obj.Giorno, obj.Mese, obj.Anno);

                    if (obj.SommaOre > tmpMaxValue)
                        tmpMaxValue = obj.SommaOre + 10;

                    item.c.push({ v: desc });
                    item.c.push({ v: obj.SommaOre });

                    $scope.graficoPerformance.data.rows.push(item);

                    if (tmpMaxValue > vm.maxValue)
                        vm.maxValue = tmpMaxValue;
                });

                vm.loading = false;
            });
        }
    }
})();
